"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyType = void 0;
var PropertyType;
(function (PropertyType) {
    PropertyType[PropertyType["Apartment"] = 0] = "Apartment";
    PropertyType[PropertyType["House"] = 1] = "House";
    PropertyType[PropertyType["SecondaryUnit"] = 2] = "SecondaryUnit";
    PropertyType[PropertyType["UniqueSpace"] = 3] = "UniqueSpace";
    PropertyType[PropertyType["Bed"] = 4] = "Bed";
    PropertyType[PropertyType["Hotel"] = 5] = "Hotel";
})(PropertyType = exports.PropertyType || (exports.PropertyType = {}));
//# sourceMappingURL=PropertyTypeEnum.js.map